// Only the API's explicit user:null confirms a guest/expired session. A proxy
// can return HTTP 200 with HTML or incomplete JSON; that must never erase a
// saved credential or replace the cached account with a malformed profile.
export function isSessionResponse(response) {
  if (response?.success !== true || !Object.prototype.hasOwnProperty.call(response, 'user')) return false;
  const user = response.user;
  return user === null || (user && !Array.isArray(user) && typeof user === 'object'
    && Number.isSafeInteger(user.id) && user.id > 0);
}
